<template>
  <div class="about-page">
    <!-- 页眉部分 -->
    <Header></Header>

    <!-- 导航菜单 -->
    <Nav></Nav>

    <!-- 英雄区域 -->
    <div class="hero">
      <div class="hero-content">
        <h1>{{ $t("team.heroTitle") }}</h1>
        <p>{{ $t("team.heroSubtitle") }}</p>
      </div>
    </div>

    <div class="main-content">
      <!-- 团队分类标签 -->
      <div class="team-tabs">
        <div
            class="team-tab"
            :class="{ active: activeTab === 'professor' }"
            @click="activeTab = 'professor'"
        >
          {{ $t("team.professorTeam") }}
        </div>
        <div
            class="team-tab"
            :class="{ active: activeTab === 'student' }"
            @click="activeTab = 'student'"
        >
          {{ $t("team.studentTeam") }}
        </div>
      </div>

      <!-- 教授团队 -->
      <div
          v-show="activeTab === 'professor'"
          class="team-content professor-team"
      >
        <div class="professor-list">
          <div
              class="professor-item"
              v-for="p in professors"
              :key="p.id"
              @click="toDetail(p.id)"
          >
            <img
                :src="p.photo"
                alt="photo"
                class="professor-photo"
                @error="setDefaultLogo($event)"
            />
            <h3 class="professor-name">{{ p.name }}</h3>
            <p class="professor-title">{{ p.title }}</p>
            <p class="professor-research">{{ p.research }}</p>
          </div>
        </div>
        
        <!-- 加载更多链接 -->
        <a
          v-if="hasMoreProfessorTeam()"
          href="javascript:void(0)"
          class="view-more"
          @click="loadMoreProfessors"
        >
          <span v-if="professorPage.loading || associateProfessorPage.loading">加载中...</span>
          <span v-else>查看更多</span>
        </a>
        
        <!-- 没有更多数据提示 -->
        <p v-else-if="professors.length > 0" class="no-more">
          没有更多数据了
        </p>
      </div>

      <!-- 研究生团队 -->
      <div v-show="activeTab === 'student'" class="team-content student-team">
        <div class="student-list">
          <div
              class="student-item"
              v-for="s in students"
              :key="s.id"
              @click="toDetail(s.id)"
          >
            <img
                :src="s.photo"
                alt="photo"
                class="student-photo"
                @error="setDefaultLogo($event)"
            />
            <h3 class="student-name">{{ s.name }}</h3>
            <p class="student-grade">{{ s.grade }}</p>
            <p class="student-research">{{ s.research }}</p>
          </div>
        </div>
        
        <!-- 加载更多链接 -->
        <a
          v-if="hasMoreStudents()"
          href="javascript:void(0)"
          class="view-more"
          @click="loadMoreStudents"
        >
          <span v-if="studentPage.loading">加载中...</span>
          <span v-else>查看更多</span>
        </a>
        
        <!-- 没有更多数据提示 -->
        <p v-else-if="students.length > 0" class="no-more">
          没有更多数据了
        </p>
      </div>
    </div>
    <!-- 页脚 -->
    <Footer></Footer>
  </div>
</template>

<script>
import defaultLogo from "@/assets/default-logo.png";
import Header from "../../components/head.vue";
import Nav from "../../components/nav.vue";
import Footer from "../../components/footer.vue";
import {listUser} from "../../api/team";

export default {
  name: "TeamPage",
  components: {Header, Nav, Footer},
  data() {
    return {
      activeTab: "professor",
      professors: [],
      students: [],
      // 分页状态
      professorPage: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        loading: false,
      },
      associateProfessorPage: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        loading: false,
      },
      studentPage: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        loading: false,
      },
    };
  },
  methods: {
    setDefaultLogo(event) {
      event.target.src = defaultLogo;
    },
    // 处理头像URL，将后端返回的完整URL转换为相对路径走nginx代理
    formatAvatarUrl(url) {
      if (!url) return "";
      return url;
    },
    // 获取教授列表
    async getProfessorList(loadMore = false) {
      if (this.professorPage.loading) return;
      
      this.professorPage.loading = true;
      
      let UserBelong = {
        belongTeam: "professor",
        pageNum: loadMore ? this.professorPage.pageNum : 1,
        pageSize: this.professorPage.pageSize,
      };
      
      try {
        let res = await listUser(UserBelong);
        if (res.code === 0) {
          let usersData = res.rows || [];
          let newProfessors = usersData.map(user => ({
            id: user.userId,
            name: user.userName,
            title: user.postGroup,
            research: user.researchDirection,
            photo: this.formatAvatarUrl(user.avatar),
          }));
          
          if (loadMore) {
            this.professors = [...this.professors, ...newProfessors];
          } else {
            this.professors = newProfessors;
          }
          
          this.professorPage.total = res.total || 0;
          this.professorPage.pageNum = loadMore ? this.professorPage.pageNum + 1 : 2;
        }
      } catch (error) {
        console.error('加载教授列表失败:', error);
        this.$message?.error('加载教授列表失败，请重试');
      } finally {
        this.professorPage.loading = false;
      }
    },
    // 获取副教授列表
    async getAssociateProfessorList(loadMore = false) {
      if (this.associateProfessorPage.loading) return;
      
      this.associateProfessorPage.loading = true;
      
      let UserBelong = {
        belongTeam: "associateProfessor",
        pageNum: loadMore ? this.associateProfessorPage.pageNum : 1,
        pageSize: this.associateProfessorPage.pageSize,
      };
      
      try {
        let res = await listUser(UserBelong);
        if (res.code === 0) {
          let usersData = res.rows || [];
          let newProfessors = usersData.map(user => ({
            id: user.userId,
            name: user.userName,
            title: user.postGroup,
            research: user.researchDirection,
            photo: this.formatAvatarUrl(user.avatar),
          }));
          
          // 副教授数据合并到教授列表中
          if (loadMore) {
            this.professors = [...this.professors, ...newProfessors];
          } else {
            this.professors = [...this.professors, ...newProfessors];
          }
          
          this.associateProfessorPage.total = res.total || 0;
          this.associateProfessorPage.pageNum = loadMore ? this.associateProfessorPage.pageNum + 1 : 2;
        }
      } catch (error) {
        console.error('加载副教授列表失败:', error);
        this.$message?.error('加载副教授列表失败，请重试');
      } finally {
        this.associateProfessorPage.loading = false;
      }
    },
    // 获取研究生列表
    async getGraduateStudentList(loadMore = false) {
      if (this.studentPage.loading) return;
      
      this.studentPage.loading = true;
      
      let UserBelong = {
        belongTeam: "graduateStudent",
        pageNum: loadMore ? this.studentPage.pageNum : 1,
        pageSize: this.studentPage.pageSize,
      };
      
      try {
        let res = await listUser(UserBelong);
        if (res.code === 0) {
          let usersData = res.rows || [];
          let newStudents = usersData.map(user => ({
            id: user.userId,
            name: user.userName,
            grade: user.postGroup,
            research: user.researchDirection,
            photo: this.formatAvatarUrl(user.avatar),
          }));
          
          if (loadMore) {
            this.students = [...this.students, ...newStudents];
          } else {
            this.students = newStudents;
          }
          
          this.studentPage.total = res.total || 0;
          this.studentPage.pageNum = loadMore ? this.studentPage.pageNum + 1 : 2;
        }
      } catch (error) {
        console.error('加载研究生列表失败:', error);
        this.$message?.error('加载研究生列表失败，请重试');
      } finally {
        this.studentPage.loading = false;
      }
    },
    // 加载更多教授数据
    loadMoreProfessors() {
      // 先加载教授
      this.getProfessorList(true).then(() => {
        // 如果教授还有更多数据，不加载副教授
        if (this.hasMoreProfessors()) {
          return;
        }
        // 如果教授没有更多数据，加载副教授
        if (this.hasMoreAssociateProfessors()) {
          this.getAssociateProfessorList(true);
        }
      });
    },
    // 加载更多研究生数据
    loadMoreStudents() {
      this.getGraduateStudentList(true);
    },
    // 判断教授是否还有更多数据
    hasMoreProfessors() {
      return this.professors.length < this.professorPage.total;
    },
    // 判断副教授是否还有更多数据
    hasMoreAssociateProfessors() {
      const associateProfessorCount = (this.associateProfessorPage.pageNum - 1) * this.associateProfessorPage.pageSize;
      return associateProfessorCount < this.associateProfessorPage.total;
    },
    // 判断研究生是否还有更多数据
    hasMoreStudents() {
      return this.students.length < this.studentPage.total;
    },
    // 判断教授团队（包括教授和副教授）是否还有更多数据
    hasMoreProfessorTeam() {
      return this.hasMoreProfessors() || this.hasMoreAssociateProfessors();
    },
    toDetail(id) {
      this.$router.push({
        path: "/team/detail/" + id,
      });
    },
  },
  mounted() {
    this.getProfessorList();
    this.getAssociateProfessorList();
    this.getGraduateStudentList();
  },
};
</script>

<style scoped>
.hero {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
  url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="400"><rect width="1200" height="400" fill="%23004080"/><circle cx="200" cy="150" r="50" fill="%23FFD700" opacity="0.3"/><circle cx="800" cy="250" r="80" fill="%23FFD700" opacity="0.2"/><rect x="400" y="100" width="300" height="200" fill="%23FFD700" opacity="0.1"/></svg>');
  background-size: cover;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
}

.hero-content h1 {
  font-size: 2.5em;
  margin-bottom: 20px;
}

.hero-content p {
  font-size: 1.1em;
}

/* ==================== 主体内容 ==================== */
.main-content {
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
}

/* ==================== 团队标签 ==================== */
.team-tabs {
  display: flex;
  justify-content: center;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.team-tab {
  padding: 14px 28px;
  font-size: 1.05rem;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.team-tab:hover {
  color: #0055aa;
}

.team-tab.active {
  color: #003366;
  font-weight: 600;
}

.team-tab.active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 100%;
  height: 3px;
  background-color: #003366;
  border-radius: 2px;
}

/* ==================== 教授团队 ==================== */
.professor-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}

.professor-item {
  background: #fff;
  padding: 20px;
  width: 260px;
  text-align: center;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.professor-item:hover {
  transform: translateY(-6px);
}

.professor-photo {
  width: 140px;
  height: 140px;
  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 15px;
}

.professor-name {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 8px;
}

.professor-title {
  font-size: 0.95rem;
  color: #555;
  margin-bottom: 8px;
}

.professor-research {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
}

/* ==================== 研究生团队 ==================== */
.student-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}

.student-item {
  background: #fff;
  padding: 20px;
  width: 220px;
  text-align: center;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.student-item:hover {
  transform: translateY(-6px);
}

.student-photo {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 15px;
}

.student-name {
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 6px;
}

.student-grade {
  font-size: 0.9rem;
  color: #555;
  margin-bottom: 6px;
}

.student-research {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
}

/* ==================== 响应式 ==================== */
@media (max-width: 768px) {
  .team-tab {
    padding: 10px 18px;
    font-size: 0.95rem;
  }

  .professor-item,
  .student-item {
    width: 80%;
    max-width: 300px;
  }

  .professor-photo {
    width: 120px;
    height: 120px;
  }

  .student-photo {
    width: 100px;
    height: 100px;
  }
}

/* ==================== 加载更多链接 ==================== */
.view-more {
  display: block;
  text-align: center;
  margin: 20px auto 0;
  color: #004080;
  text-decoration: none;
  font-weight: bold;
}

.view-more:hover {
  text-decoration: underline;
}

.no-more {
  text-align: center;
  color: #999;
  font-size: 0.9rem;
  margin-top: 20px;
}
</style>
